module.exports = __webpack_public_path__ + "img/Photo37.9ba12bde.jpg";